import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  type OnInit,
  ViewChild
} from '@angular/core';
import {CartResponseDetail, OnGoingOrder} from "../../../../@domain/on-going-order";
import {ApiBaseService} from "../../../../../../projects/vendors/src/lib/services/api-base.service";
import {OrderStatus} from "../../../../@application/enum/order-status.enum";
import {OrderType} from "../../../../@application/enum/order-type.enums";
import {PaymentStatus} from "../../../../@application/enum/payment-status.enum";
import {RestaurantTable} from "../../../../@domain/restaurent-table";
import {FoodExtra} from "../../../../@domain/food-extras";
import {IOrderStatus} from "../../../../@domain/order-status";
import {
  FormHelper,
  KeyString,
  KeyValue
} from "../../../../../../projects/vendors/src/lib/services/form-helper";
import {FoodItemPipe} from "../../../../../../projects/vendors/src/lib/pipe/food-item.pipe";
import {Router} from "@angular/router";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AlertService} from "../../../../../../projects/vendors/src/lib/services/alert.service";
import {VendorsService} from "../../../../../../projects/vendors/src/lib/vendors.service";
import {Subscription} from "rxjs";
import {TableNamePipe} from "../../../../../../projects/vendors/src/lib/pipe/table-name.pipe";
import {FoodItem} from "../../../../../../projects/vendors/src/lib/@domain/food-item";
import {FoodItemQuantity} from "../../../../@domain/food-item-quantity";
import {NzModalService} from "ng-zorro-antd/modal";
import {ApiEnum} from "../../../../@application/enum/api.enum";
import {PathEnum} from "../../../../@application/enum/path.enum";
import {OngoingOrderFilterDialogComponent} from "../ongoing-order-filter-dialog/ongoing-order-filter-dialog.component";
import {CheckOutDialogBoxComponent} from "../check-out-dialog-box/check-out-dialog-box.component";
import {OrderDeleteDialogComponent} from "../order-delete-dialog/order-delete-dialog.component";
import {CartDeleteDialogComponent} from "../../place-order/order-cart/cart-delete-dialog/cart-delete-dialog.component";
import {UpdateFoodStatusDialogComponent} from "../update-food-status-dialog/update-food-status-dialog.component";
import {OrderBillDialogComponent} from "../order-bill-dialog/order-bill-dialog.component";
import {StorageService} from "../../../../../../projects/vendors/src/lib/services/storage.service";
import {KotPrintDialogComponent} from "../../place-order/order-cart/kot-print-dialog/kot-print-dialog.component";
import {KotPrinterViewComponent} from "./kot-printer-view/kot-printer-view.component";

@Component({
    selector: 'app-all-orders',
    templateUrl: './all-orders.component.html',
    styleUrl: './all-orders.component.scss',
    standalone: false
})
export class AllOrdersComponent  implements OnInit, OnDestroy, AfterViewInit  {
  onGoingOrder = [] as OnGoingOrder[]
  _onGoingOrder = [] as OnGoingOrder[]
  totalValue !: number
  apiBaseService = inject(ApiBaseService)

  orderStatus = OrderStatus
  orderTypes = OrderType
  paymentStatus = PaymentStatus
  tables = [] as RestaurantTable[];
  foodExtras = [] as FoodExtra[];
  iOrderStatus = {} as IOrderStatus;
  tableNameKeyValue = [] as KeyString[]
  userNameKeyValue = [] as KeyValue[]
  sectionNameKeyValue = [] as KeyString[]
  orderStatusKeyValue = [] as KeyValue[]
  orderTypeKeyValue = [] as KeyValue[]
  status!: number
  orderType!: number
  userName!: string
  selectedTables = [] as string[]
  selectedSections = [] as string[]
  private foodNamePipe = inject(FoodItemPipe)
  private router = inject(Router)
  private dialog = inject(MatDialog)
  private alertService = inject(AlertService)
  private vendorsService = inject(VendorsService)
  newOrderSubscription!: Subscription;
  orderStatusSubscription!: Subscription;
  tableNamePipe = inject(TableNamePipe)
  private storageService = inject(StorageService)
  orderCloseSubscription!: Subscription
  foodItems = [] as FoodItem[];
  foodItemQuantity = [] as FoodItemQuantity[]
  items = [] as any[];
  searchValue!: any;
  splitBills = [] as SplitBill[]
  modal = inject(NzModalService)
  isVisible = false;
  selectedOrderType = 1;
  orderTypeKeyValueF = [] as KeyValue[]
  printOrder = {} as OnGoingOrder
  type!: string
  @ViewChild('searchLive', { static: false }) searchInput!: ElementRef;
  selectedFilters = {
    orderType: null,
    tableName: [] as string[],
    sectionName: [] as string[],
    orderStatus: null
  };
  constructor() {
    this.orderStatusKeyValue = FormHelper.GetOrderStatusList()
    this.orderTypeKeyValue = FormHelper.GetOderType()
    this.orderTypeKeyValueF = FormHelper.GetOderTypeNoFunc()
  }

  ngOnInit() {
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: value => {
        if (value)
          this.getAllOngoingOrder()
      }
    })
    this.newOrderSubscription = this.vendorsService.newOrderSubject.subscribe({
      next: value => {
        if (value)
          this.getAllOngoingOrder()
      }
    })
    this.orderStatusSubscription = this.vendorsService.orderStatusSubject.subscribe({
      next: value => {
        if (value)
          this.getAllOngoingOrder()
      }
    })
    this.getFoodItem();
    this.getFoodExtras()
    this.getOrderStatus()
    this.getTables()
    this.getAllOngoingOrder()
    this.getFoodItemQuantity()
    setInterval(() => {
      this.items = [...this.items]; // Trigger change detection
    }, 60000); // Update every minute
  }

  isNameContainsSpecialCharacter(name: string): boolean {
    const foodName = this.foodNamePipe.transform(name, this.foodItems);
    const bracketsRegex = /[()]/;
    return bracketsRegex.test(foodName);
  }



  isMobileScreen(): boolean {
    return window.innerWidth <= 1200;
  }


  ngAfterViewInit() {
    setTimeout(() => this.searchInput?.nativeElement?.focus(), 0);
  }



  onItemChecked(orderId: string, id: string, checked: boolean): void {
    if (checked) {
      if (this.splitBills.some(x => x.orderId === orderId)) {
        this.splitBills.find(x => x.orderId === orderId)?.cartId.push(id)
      } else {
        this.splitBills.push({ orderId: orderId, cartId: [id] })
      }
    } else {
      const bill = this.splitBills.find(x => x.orderId === orderId);
      if (bill) {
        const index = bill.cartId.indexOf(id);
        if (index > -1) {
          bill.cartId.splice(index, 1);
        }
      }
      if (this.splitBills.find(x => x.orderId === orderId)?.cartId.length === 0) {
        this.splitBills.splice(this.splitBills.findIndex(x => x.orderId === orderId), 1)
      }
      this.splitOrderDetails(orderId)
    }
    this.storageService.saveToLocalStorage('splitBills', this.splitBills)
  }

  private splitOrderDetails(orderId: string): void {
    const item = this.items.find(x => x.orderId === orderId);
    const splitBillCartIds = this.splitBills.find(y => y.orderId === orderId)?.cartId || [];
    if (item) {
      item.splitOrderDetails = item.cartResponseDetails.filter((x: CartResponseDetail) => splitBillCartIds.includes(x.id));
      item.notSplitOrderDetails = item.cartResponseDetails.filter((x: CartResponseDetail) => !splitBillCartIds.includes(x.id));
    }
  }

  /**
   * Every criterion is applied together against the untouched source list. Each filter
   * used to reset from _onGoingOrder on its own, so picking a table and then a user
   * silently dropped the table filter.
   */
  applyFilters() {
    this.onGoingOrder = this._onGoingOrder.filter(order => {
      if (this.searchValue && !order.orderNumber.toLowerCase().includes(this.searchValue.toLowerCase())) return false;
      if (this.orderType != null && order.orderType !== this.orderType) return false;
      if (this.status != null && order.orderingStatus !== this.status) return false;
      if (this.userName && order.createdBy !== this.userName) return false;
      if (this.selectedSections?.length && !this.selectedSections.includes(order.sectionName)) return false;
      if (this.selectedTables?.length && !order.tables.some(t => this.selectedTables.includes(t))) return false;
      return true;
    });
    this.items = this.onGoingOrder;
  }

  liveSearch() {
    this.applyFilters();
  }

  onSelectTableMulti(tableIds: string[]) {
    this.selectedTables = tableIds ?? [];
    this.applyFilters();
  }

  onSelectSection(sectionNames: string[]) {
    this.selectedSections = sectionNames ?? [];
    this.applyFilters();
  }

  onSelectUser(userName: string): void {
    this.userName = userName;
    this.applyFilters();
  }

  onSelectStatus(status: number) {
    this.status = status;
    this.applyFilters();
  }

  onSelectOrderType(orderType: number) {
    this.orderType = orderType;
    this.applyFilters();
  }

  getFoodExtras() {
    this.apiBaseService.GET<FoodExtra[]>([ApiEnum.FoodModule, ApiEnum.FoodExtra])
      .subscribe(res => {
        this.foodExtras = res;
      });
  }

  getFoodItem(): void {
    this.apiBaseService.GET<FoodItem[]>([ApiEnum.FoodModule, ApiEnum.Food])
      .subscribe(res => {
        this.foodItems = res;
      });
  }


  private getAllOngoingOrder(): void {
    this.apiBaseService.GET<OnGoingOrder[]>([ApiEnum.RestaurantModule, ApiEnum.Cart, ApiEnum.GetAll])
      .subscribe({
        next: response => {
          this.onGoingOrder = response.filter(x => x.orderingStatus !== OrderStatus.Closed)
          this._onGoingOrder = response.filter(x => x.orderingStatus !== OrderStatus.Closed)
          this.totalValue = this.onGoingOrder.map(x => x.totalPrice).reduce((a, b) => a + b, 0)
          this.items = this.onGoingOrder

          // Build table dropdown from ongoing orders
          const tableIdSet = new Set<string>();
          this._onGoingOrder.forEach(order => order.tables.forEach(t => tableIdSet.add(t)));
          this.tableNameKeyValue = Array.from(tableIdSet).map(tableId => {
            const table = this.tables.find(t => t.id === tableId);
            return { key: tableId, value: table?.name || tableId };
          });

          const onGoingUserIds = new Set<string>();
          this._onGoingOrder.forEach(order => onGoingUserIds.add(order.createdBy));
          this.userNameKeyValue = Array.from(onGoingUserIds).map(userId => {
            const order = this._onGoingOrder.find(o => o.createdBy === userId);
            return { key: userId, value: order?.createdByName || userId };
          });

          // Orders carry the section name, not an id, so the name is the filter key.
          const sectionNames = new Set<string>();
          this._onGoingOrder.forEach(order => { if (order.sectionName) sectionNames.add(order.sectionName) });
          this.sectionNameKeyValue = Array.from(sectionNames).map(name => ({ key: name, value: name }));

          // Rebuild from the full list: narrowing the previously narrowed array made
          // statuses vanish for good after a few refreshes.
          const onGoingStatusIds = this._onGoingOrder.map(order => order.orderingStatus);
          this.orderStatusKeyValue = FormHelper.GetOrderStatusList()
            .filter(status => onGoingStatusIds.includes(status.key));

          this.applyFilters();

          this.splitBills = this.storageService.getFromLocalStorage('splitBills') || []
          this.items.forEach((item: OnGoingOrder) => {
            this.splitOrderDetails(item.orderId)
          })
        }
      });
  }


  private getOrderStatus() {
    this.apiBaseService.GET<IOrderStatus>([ApiEnum.RestaurantModule, ApiEnum.Order, ApiEnum.OrderStatus])
      .subscribe({
        next: response => {
          this.iOrderStatus = response;
        }
      })
  }

  getTables(): void {
    this.apiBaseService.GET<RestaurantTable[]>([ApiEnum.RestaurantModule, ApiEnum.RestaurantTable])
      .subscribe(res => {
        this.tables = res;
        // this.tableNameKeyValue = res.map((item: any) => {
        //   return {
        //     value: item.id,
        //     label: item.name,
        //     checked: false
        //   }
        // })
        // this.tableNameKeyValue = [...new Set(this.tableNameKeyValue)];
      })
  }

  getElapsedTime(createdTime: string): string {
    const now = new Date();
    const elapsedMs = now.getTime() - new Date(createdTime).getTime();

    const seconds = Math.floor(elapsedMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day`;
    } else if (hours > 0) {
      return `${hours} hour`;
    } else if (minutes > 0) {
      return `${minutes} min`;
    } else {
      return `${seconds} sec`;
    }
  }


  onFullView(orderId: string) {
    const queryParams: any = {
      orderId: orderId
    };
    this.router.navigate([PathEnum.Home, PathEnum.PlaceOrder], { queryParams: queryParams })
  }

  onFilterOrder() {
    const dialogRef = this.dialog.open(OngoingOrderFilterDialogComponent, {
      width: '80%',
      data: {
        orderTypeKeyValue: this.orderTypeKeyValue,
        tableNameKeyValue: this.tableNameKeyValue,
        userNameKeyValue: this.userNameKeyValue,
        sectionNameKeyValue: this.sectionNameKeyValue,
        orderStatusKeyValue: this.orderStatusKeyValue,
        selectedFilters: this.selectedFilters,
      },
    });

    dialogRef.componentInstance.filterChange.subscribe((selectedFilters) => {
      if (!selectedFilters) return;
      this.selectedFilters = selectedFilters;
      // Mirror the dialog straight onto the bound fields; applyFilters() combines them.
      // Applying each one in turn used to let the last selection undo the others.
      this.orderType = selectedFilters.orderType;
      this.selectedTables = selectedFilters.tableName ?? [];
      this.selectedSections = selectedFilters.sectionName ?? [];
      this.userName = selectedFilters.userName;
      this.status = selectedFilters.orderStatus;
      this.searchValue = selectedFilters.searchValue;
      this.applyFilters();
    });
  }


  onCheckout(item: OnGoingOrder) {
    const dialogRef = this.dialog.open(CheckOutDialogBoxComponent, {
      width: '70vw',
      maxWidth: '70vw',
      height: '90vh',
      maxHeight: '90vh',
      panelClass: 'checkout-dialog-panel',
      data: {
        onGoingOrder: item,
        foods: this.foodItems,
        tables: this.tables
      }
    });

    dialogRef.afterClosed().subscribe({
      next: value => {
        // Only a settled bill closes with a value; ESC/backdrop must leave the list alone.
        if (value) {
          this.getAllOngoingOrder()
        }
      }
    })
  }

  onDelete(item: OnGoingOrder) {
    const dialogRef = this.dialog.open(OrderDeleteDialogComponent, {
      width: '350px',
      data: item
    });
    this.reloadAfterClose(dialogRef);
  }

  private reloadAfterClose(dialogRef: MatDialogRef<any>) {
    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res != true)
          this.getAllOngoingOrder()
      }
    });
  }

  onDeleteFood(foodItem: CartResponseDetail) {
    const dialogRef = this.dialog.open(CartDeleteDialogComponent, {
      width: '350px',
      data: this.foodNamePipe.transform(foodItem.foodId, this.foodItems)
    })
    dialogRef.afterClosed().subscribe({
      next: value => {
        // The dialog closes with the reason on confirm, and with true on cancel.
        if (value != true) {
          this.deleteFood(value, foodItem.id)
        }
      }
    })
  }

  private deleteFood(deletedReason: string, foodItemId: string): void {
    this.apiBaseService.POST_API([ApiEnum.RestaurantModule, ApiEnum.Cart, ApiEnum.Delete], {
      id: foodItemId,
      deleteReason: deletedReason,
      isAdminApproved: true
    }, true, true, 'Successfully Deleted!').subscribe({
      next: _res => {
        this.getAllOngoingOrder()
      }
    })
  }

  /** Same dialog as a single item, but applied to every item of the order in one action. */
  onUpdateOrderStatus(item: OnGoingOrder) {
    const dialogRef = this.dialog.open(UpdateFoodStatusDialogComponent, {
      width: '600px',
      data: {
        itemName: `Order ${item.orderNumber}`,
        orderId: item.orderId,
        cartIds: item.cartResponseDetails.map(x => x.id),
        tableName: this.tableName(item.tables),
      }
    });
    this.reloadAfterClose(dialogRef);
  }

  onUpdateFood(foodItem: CartResponseDetail, orderId: string, createdBy: any, tables: any) {
    const dialogRef = this.dialog.open(UpdateFoodStatusDialogComponent, {
      width: '600px',
      data: {
        itemName: this.foodNamePipe.transform(foodItem.foodId, this.foodItems),
        orderId: orderId,
        foodItem: foodItem,
        tableName: this.tableName(tables),
      }
    });
    this.reloadAfterClose(dialogRef);
  }

  /**
   * Read lazily — HomeComponent writes 'restaurantDetail' from an async GET, so a value
   * latched in ngOnInit is missing on a hard refresh straight into this route.
   */
  get counterService(): boolean {
    return this.storageService
      .getFromSessionStorage('restaurantDetail')?.counterServiceEnabled ?? false;
  }

  /**
   * A paid counter order is a finished transaction. Re-billing or deleting it would leave the
   * bill out of step with the order, so those actions are removed from the card. Updating an
   * item's kitchen status stays available — that is the counter's job after payment.
   */
  isPaidCounterOrder(item: OnGoingOrder): boolean {
    return item.orderType === OrderType.Pos
      && item.paymentStatus === PaymentStatus.Paid;
  }

  /** Counter service and POS orders are billed up front, so there is nothing to split. */
  canSplit(item: OnGoingOrder): boolean {
    return !this.counterService && item.orderType !== OrderType.Pos;
  }

  tableName(tables: string[]): string {
    if (tables.length == 0) {
      return 'POS'
    } else if (tables.length == 1) {
      return this.tables.find(x => x.id == tables[0])?.name!
    }
    return tables.map(x => this.tableNamePipe.transform(x, this.tables)).join(', ')
  }

  getReferenceTypeLabel(type: number | null): string {
    switch (type) {
      case 1: return 'POS';
      case 2: return 'QR';
      default: return '';
    }
  }

  getReferenceTypeColor(type: number | null): string {
    switch (type) {
      case 1: return 'blue';
      case 2: return 'green';
      default: return 'default';
    }
  }

  private getFoodItemQuantity(): void {
    this.apiBaseService.GET<FoodItemQuantity[]>([ApiEnum.FoodModule, ApiEnum.FoodItemQuantityTag])
      .subscribe(res => {
        this.foodItemQuantity = res
      });
  }

  ngOnDestroy(): void {
    this.orderCloseSubscription.unsubscribe()
    this.newOrderSubscription.unsubscribe();
    this.orderStatusSubscription.unsubscribe();
  }

  onSplitBill(item: OnGoingOrder) {
    const splitBillCartIds = this.splitBills.find(y => y.orderId === item.orderId)?.cartId || [];
    if (splitBillCartIds.length === 0) {
      this.alertService.showInfo('Info', 'Please select items to split the bill.')
      return;
    }
    this.modal.confirm({
      nzTitle: 'Split Bill',
      nzContent: 'Do you want to split the bill?',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOnOk: () => this.splitOrderDetails(item.orderId),
      nzCancelText: 'No',
    });
  }

  itemChecked(orderId: string, id: string): boolean {
    return this.splitBills.some(x => x.orderId === orderId && x.cartId.includes(id))
  }

  onPrintOrder(order: OnGoingOrder, type: string) {
    this.isVisible = true
    this.printOrder = order
    this.type = type
  }

  handleCancel() {
    this.isVisible = false
  }

  handleOk() {
    this.isVisible = false
    const orderData = structuredClone(this.printOrder)
    orderData.orderType = this.selectedOrderType
    if (this.type === 'notSplit') {
      orderData.cartResponseDetails = orderData.notSplitOrderDetails
    } else {
      orderData.cartResponseDetails = orderData.splitOrderDetails
    }
    this.dialog.open(OrderBillDialogComponent, {
      width: '50%',
      data: {
        onGoingOrder: orderData,
        foods: this.foodItems,
      }
    })
  }

  onKotPrint(order: OnGoingOrder) {
    this.dialog.open(KotPrinterViewComponent, {
      width: '70vw',
      maxWidth: '70vw',
      height: '90vh',
      maxHeight: '90vh',
      panelClass: 'kot-print-panel',
      data: {
        order: order,
        foodItems: this.foodItems
      }
    })
  }
}

export interface SplitBill {
  orderId: string
  cartId: string[]
}
